import { gql } from "@apollo/client";

export default gql`
  mutation deleteMemberAvailabilityExceptions($id: ID!) {
    deleteMemberAvailabilityExceptions(id: $id)
  }
`;
